import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "company",
  initialState: {},
  reducers: {
    COMPANY_DETAILS: (user, action) => {
        return { ...user, ...action.payload };
    },
  },
});

export const { COMPANY_DETAILS } = slice.actions;

export default slice.reducer;
